import { PiCaretDown, PiCaretUp } from "react-icons/pi";
import DefaultAvatar from "../../../../../components/avatar/defaultAvatar";
import DefaultInput from "../../../../../components/inputs/defaultInput";
import { IoCheckmark } from "react-icons/io5";
import { NoDataFound } from "../../../../../components/table/tableComponent";
import TableSkeleton from "../../../../../components/skeleton/tableSkeleton";

const PayrollTable = ({
  payrollList,
  loading,
  sortOrder,
  setSortOrder,
  handleUpdateSalary,
  handleUpdateForMakeSalary,
  handleUpdateForAll,
}) => {
  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full border-collapse bg-white text-gray-600 text-sm">
        <thead className="bg-gray-100">
          <tr className="border-b border-gray-200">
            <th
              rowSpan={2}
              className="px-4 py-3 font-medium text-center border-r border-gray-200 cursor-pointer sticky left-0 bg-white z-10"
              onClick={() => setSortOrder(sortOrder === "asc" ? "desc" : "asc")}
            >
              <div>
                <div
                  className="flex items-center gap-2 cursor-pointer"
                  onClick={() => {
                    if (!loading && payrollList?.length) {
                      handleUpdateForAll();
                    }
                  }}
                >
                  <span
                    className={`rounded-md min-w-6 w-6 min-h-6 h-6 flex items-center justify-center border `}
                  >
                    <span
                      className={`w-4 h-4 rounded-sm ${
                        payrollList &&
                        !!payrollList.length &&
                        payrollList.every((data) => data.forPaid)
                          ? "bg-success-500 text-white"
                          : "bg-white"
                      }`}
                    ></span>
                  </span>
                  <span>Employee Name</span>
                </div>
              </div>
            </th>
             
            <th className="px-4 py-3 font-medium text-center border-r border-gray-200">
              <div className="flex flex-col">
                <span className="text-xs text-disabled truncate">
                  Days in Month / Salary
                </span>
              </div>
            </th>
            <th className="px-4 py-3 font-medium text-center border-r border-gray-200">
              Weekend
            </th>
            <th className="px-4 py-3 font-medium w-24 text-center border-r border-gray-200">
              Holidays
            </th>
            <th className="px-4 py-3 font-medium text-center border-r border-gray-200">
              Expected Payable Days
            </th>

           

            <th className="px-4 py-3 font-medium text-center border-r border-gray-200">
              <div className="flex flex-col">
                <span className="text-xs text-disabled truncate">
                  Absent / Deduction
                </span>
              </div>
            </th>
           
           
            <th className="px-4 py-3 font-medium text-center border-r border-gray-200">
              <div className="flex flex-col">
                <span className="text-xs text-disabled truncate">
                Leave / Payable
                </span>
              </div>
            </th>
            

           
            <th className="px-4 py-3 font-medium text-center border-r border-gray-200">
              <div className="flex flex-col">
                <span className="text-xs text-disabled truncate">
                  Unpaid Leave / Deduction
                </span>
              </div>
            </th>
            <th className="px-4 py-3 font-medium text-center border-r border-gray-200">
              <div className="flex flex-col">
                <span className="text-xs text-disabled truncate">
                  Present / Payable
                </span>
              </div>
            </th>
            <th className="px-4 py-3 font-medium w-24 text-center border-r border-gray-200">
              Payable Days
            </th>
            <th className="px-4 py-3 font-medium text-center border-r border-gray-200">
              Total Hours
            </th>
          

            <th className="px-4 py-3 font-medium text-center border-r border-gray-200">
              Calculated Salary
            </th>
            <th className="px-4 py-3 font-medium text-center border-r border-gray-200">
              Adjustments
            </th>
            <th className="px-4 py-3 font-medium text-center border-r border-gray-200">
              Final Salary
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 border-t border-gray-100">
          {loading ? (
            <TableSkeleton colSpan={12} />
          ) : payrollList && payrollList.length > 0 ? (
            payrollList
              .filter((data) => !data.is_paid)
              .map((data, index) => (
                <tr
                  className={`${data.is_paid ? "bg-green-50" : ""}`}
                  key={`user-pay-${index}`}
                >
                  <td className="px-4 py-3 text-gray-600 sticky left-0 z-10 bg-white">
                    <div className="flex items-center gap-2">
                      <div
                        className="sticky left-0 bg-white z-10 cursor-pointer"
                        onClick={() => {
                          if (data.status != 1) {
                            if (!data.is_paid) {
                              handleUpdateForMakeSalary(data.id);
                            }
                          }
                        }}
                      >
                        <span
                          className={`rounded-md min-w-6 w-6 min-h-6 h-6 flex items-center justify-center border`}
                        >
                          <span
                            className={`w-4 h-4 rounded-sm  ${
                              data.status === 1
                                ? "bg-gray-300"
                                : data.forPaid
                                ? "bg-success-500"
                                : ""
                            }`}
                          />
                        </span>
                      </div>

                      <div className="flex items-center justify-center bg-indigo-50 border border-indigo-300 text-indigo-600 min-h-8 min-w-8 rounded-full">
                        <DefaultAvatar />
                      </div>
                      <span>{data?.staff?.name}</span>
                    </div>
                  </td>
                  
                  <td className="px-4 py-3 text-center text-gray-600">
                  <div className="flex flex-col">
                      {data.total_days === 0 ? (
                        "-"
                      ) : (
                        <span className="text-xs text-green-500">
                          <b className="text-green-600">{data.total_days}</b> / ₹{" "}
                          {data.net_salary}
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-center text-gray-600">
                    {data.weekend}
                  </td>
                  <td className="px-4 py-3 text-center text-gray-600">
                    {data.holidays}
                  </td>
                  
                    <td className="px-4 py-3 text-center text-gray-600">
                      {data?.expected_payable_days}
                    </td>
                    <td className="px-4 py-3 text-center text-gray-600">
                    <div className="flex flex-col">
                      {!data.absent_day_salary || data.absent === 0 ? (
                        "-"
                      ) : (
                        <span className="text-xs text-red-500">
                          <b className="text-red-600">{data.absent}</b> / ₹{" "}
                          {data.absent_day_salary}
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-center text-gray-600">
                    <div className="flex flex-col">
                      {data.leave === 0 ? (
                        "-"
                      ) : (
                        <span className="text-xs text-green-500">
                          <b className="text-green-600">{data.leave}</b> / ₹{" "}
                          {data.paid_leave_amount}
                        </span>
                      )}
                    </div>
                  </td>
                  
                  
                  <td className="px-4 py-3 text-center text-gray-600">
                    <div className="flex flex-col">
                      {data.unpaid_leaves === 0 ? (
                        "-"
                      ) : (
                        <span className="text-xs text-red-500">
                          <b className="text-red-600">{data.unpaid_leaves}</b> /
                          ₹ {data.leave_deduction}
                        </span>
                      )}
                    </div>
                  </td>
                  
                 
                  <td className="px-4 py-3 text-center text-gray-600">
                    <div className="flex flex-col">
                      {data.present === 0 ? (
                        "-"
                      ) : (
                        <span className="text-xs text-green-500">
                          <b className="text-green-600">{data.present}</b> / ₹{" "}
                          {data.present_day_salary}
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-center text-gray-600">
                    {data.payable_days}
                  </td>{" "}
                  <td className="px-4 py-3 text-center text-gray-600">
                    {data.total_hours}
                  </td>
                 
                  <td className="px-4 py-3 text-center text-gray-600">
                    {data.calculated_salary}
                  </td>
                  <td className="px-4 py-3 text-center text-gray-600">
                    <DefaultInput
                      placeholder={"Add Amount"}
                      value={data.adjustments}
                      onChange={(e) =>
                        handleUpdateSalary(data.id, e.target.value)
                      }
                      readOnly={data.is_paid}
                    />
                  </td>
                  <td className="px-4 py-3 text-center text-gray-600">
                    {data.netSalary}
                  </td>
                </tr>
              ))
          ) : (
            <tr>
              <NoDataFound colSpan={12} />
              {/* <NoData /> */}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PayrollTable;
